import React from 'react';
import "./cardtheme.scss";
import { Link } from 'react-router-dom';
import {FaEdit} from "react-icons/fa";
import {MdDelete} from "react-icons/md";

const CardTheme = ({ themes, handleDelete }) => {

  return (
    <div className="cardTheme">
      <p>{themes.nomTheme}</p>

      <div className='buttonContainer' >
        <Link to={`/theme/updateTheme/${themes.id}`}>
          <button><FaEdit /></button>
        </Link>

        <button className='btn' onClick={handleDelete}><MdDelete /></button>
      </div>
    </div>
  );
}

export default CardTheme;
